"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  $(Dom.accordionHeading).on("click", function (event) {
    event.preventDefault();
    handlers.accordionToggle($(this));
  });
};
